module.exports = __webpack_public_path__ + "static/img/logo-amc.c916086.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/logo-amc.png
// module id = q3Vr
// module chunks = 0